import { getRequest } from '../Util/utils';

export type LinkCode = {
  code: string;
  business_number: string | null;
  wa_me_link: string | null;
  expires_at: string;
};

export type LinkStatus =
  | { linked: false }
  | { linked: true; wa_id_masked: string; linked_at: string };

function simpleResponse<T>(response: Response): Promise<T> {
  if (response.ok) return response.json();
  throw `${response.status} ${response.statusText}`;
}

export async function getLinkCode(): Promise<LinkCode> {
  return window
    .fetch('/account/whatsapp/link-code', { ...getRequest(), method: 'POST' })
    .then((r) => simpleResponse<LinkCode>(r));
}

export async function getStatus(): Promise<LinkStatus> {
  return window
    .fetch('/account/whatsapp/status', getRequest())
    .then((r) => simpleResponse<LinkStatus>(r));
}

export async function unlink(): Promise<{ success: boolean }> {
  return window
    .fetch('/account/whatsapp/unlink', { ...getRequest(), method: 'POST' })
    .then((r) => simpleResponse<{ success: boolean }>(r));
}
